export default "__VITE_ASSET__CfhVriGK__"